import styled from 'styled-components'

interface IStyle {
  margin?: boolean
}

const PathContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  max-height: 24px;

  margin-bottom: 20px;
  margin-left: ${(props: IStyle) => {
    if (props.margin) return '30px'
    return 0
  }};
  /* margin-top: -50px; */
  /* z-index: 200; */

  .path {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    color: #9c948c;

    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.14px;
  }
`

export default PathContainer
